import React from 'react'

export const MenuItemIcon = ({children}) => {
	return <div className="menuItemIcon">
		{children}
	</div>
}